/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRearrange = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 14v8H2v-8zm-2 2H4v4h6zm9.121-7.707-1.414 1.414L14 6l3.707-3.707 1.414 1.414L17.828 5H22v14h-8v-2h6V7h-2.17zM12 2v8H2V2zm-2 2H4v4h6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRearrange as Rearrange };
